import React from "react";

export const GlobalContext = React.createContext();



export const GlobalProvider = ({children}) => {
    const [cookiesVisible, setCookiesVisible] = React.useState(false)

    const value = {
        cookiesVisible,
        setCookiesVisible
    }

    return(
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    )


}